<template>
  <v-layout>
    <v-flex>
      <button
        class="d-flex align-center font-size--12 font-weight-bold color--nice-grey"
        @click="preDay()"
      >
        <v-icon>mdi-chevron-left</v-icon>
        <span>이전</span>
      </button>
    </v-flex>
    <v-flex class="d-flex justify-center">
      <span class="font-weight-black d-flex align-center" @click="$emit('onClickDate')">
        <img class="icon" src="@/assets/images/icons/earlypay/calendar.svg" />
        {{ showDate }}
      </span>
    </v-flex>
    <v-flex class="d-flex justify-end">
      <button
        class="d-flex align-center font-size--12 font-weight-bold color--nice-grey"
        @click="nextDay()"
        :disabled="max && $moment(max).isSameOrBefore($moment(date))"
      >
        <span>다음</span>
        <v-icon>mdi-chevron-right</v-icon>
      </button>
    </v-flex>
  </v-layout>
</template>

<script>
import dateSliderMixin from '@/components/earlypay/dateSliderMixin'
export default {
  mixins: [dateSliderMixin],
}
</script>

<style lang="scss" scoped>
button:disabled {
  opacity: 0;
}

.icon {
  width: 28px;
}
</style>
